import { ref, reactive, computed, onMounted } from 'vue'
import { defineStore } from 'pinia'

import Ajax from '@utils/ajax'

import Service from '@model/service'
import Category from '@model/category'

import { useCategory } from '@store/category'
import { useSettings } from '@store/settings'
const $category = useCategory()
const $settings = useSettings()

export const useService = defineStore('service', () => {
    const categories = ref([])
    const services = ref([])

    const state = reactive({
        draggingOverCategory: '',
        draggedCategory: '',
        draggingOverService: '',
        draggedService: '',
    })


    // Loader.
    const isCategoryLoaded = ref(false)
    // Fetch Categories
    // const fetchCategories = async (categoryId = null) => {
    //     const response = await Ajax.get('admin_get_categories', { service_id: categoryId })
    //     return response.data
    // }

    const fetchCategories = async () => {
        categories.value = await Category.init().all()

        if (!categories.value.find(category => category.name == 'Uncategorised')) {
            await $category.model().create({
                name: 'Uncategorised',
                short_description: 'Default category',
                status: "publish",
                meta: {
                    color: "#333333",
                    priority: 999
                }
            })
            fetchCategories()
        }

        return categories.value
    }

    const model = (service_id = null) => {
        return new Service({ service_id: service_id })
    }

    // Loader.
    const isServiceLoaded = ref(false)
    // Fetch Services
    // const fetchServices = async (serviceId = null) => {
    //     const response = await Ajax.get('admin_get_services', { service_id: serviceId })
    //     if (!response.success) return []

    //     return response.data
    // }
    const fetchServices = async () => {
        return services.value = await Service.init().all()
    }

    const isLoaded = computed(() => {
        return isCategoryLoaded.value && isServiceLoaded.value
    })

    // Fetch Data.
    const fetchData = async () => {
        // isCategoryLoaded.value = false
        categories.value = await fetchCategories()
        isCategoryLoaded.value = true

        // isServiceLoaded.value = false
        services.value = await fetchServices()
        isServiceLoaded.value = true

        Log('Service', services._rawValue)
    }

    onMounted(fetchData)

    // Get Categories
    const getCategories = computed(() => {
        let cats = categories.value.map(category => {
            let s = services.value.filter(service => service.category_id == category.category_id)

            category.services = s.sort((a, b) => a.meta.order - b.meta.order)
            return category
        })

        // If a service is not in any category or category is deleted, add it to uncategorised
        // let uncategorised = cats.find(category => category.name == 'Uncategorised')

        // if (uncategorised) {
        //     let uncategorisedServices = services.value.filter(service => !cats.find(category => category.category_id == service.category_id))
        //     uncategorised.services = uncategorisedServices
        // } 

        return cats.sort((a, b) => a.meta.priority - b.meta.priority)
    })

    /***
     * Get Category by ID
     *
     * @param categoryId
     * @returns {*}
     */
    const getCategoryById = (categoryId) => {
        return categories.value.find(category => category.category_id == categoryId)
        // || {
        //     category_id: "0",
        //     name: 'Uncategorised',
        //     services: [],
        //     meta: {
        //         color: "#333333",
        //         priority: 1000,
        //         checkbox: false
        //     }
        // }
    }


    // Update Category
    const updateCategory = async (category, alert = true) => {
        // const response = await Ajax.post('admin_update_category', category)
        const response = category.category_id
            ? await $category.model(category.category_id).update(category, category.category_id)
            : await $category.model().create(category)

        if (response.success) {
            fetchData()
            alert ? Toast.success(`Category ${category.category_id ? ' updated' : 'added'}.`) : ''

            if (!category.category_id) {
                Log('updated cat', response.data)
                // Add category to categories
                // categories.value.push(response.data)
            }
        } else {
            alert ? Toast.error(response.message || 'Something went wrong.') : ''
        }

        return response
    }

    /**
     * Delete Category
     */
    const deleteCategory = async (category_id) => {
        // const choice = await Prompt.fire({
        //     title: 'Are you sure?',
        //     message: 'You won\'t be able to revert this!',
        //     ok: 'Delete',
        //     cancel: 'Dismiss',
        // })

        // if (!choice.ok) return

        // const response = await Ajax.post('admin_delete_category', { category_id })
        const response = await $category.model(category_id).delete()

        if (response.success) {
            Toast.success('Category deleted successfully')

            // Remove category from categories
            // categories.value = categories.value.filter(category => category.category_id !== category_id)
            let uncategorised = categories.value.find(category => category.name == 'Uncategorised')
            if (uncategorised) {
                let categoryServices = services.value.filter(service => service.category_id == category_id)

                categoryServices.forEach(service => {
                    updateService({
                        service_id: service.service_id,
                        category_id: uncategorised.category_id
                    }, false)
                })
            }

            fetchData()

        } else {
            // Toast.error(response.message || 'Something went wrong.')
        }


        return response
    }



    // Get Services
    const getServices = computed(() => {
        return services.value.sort((a, b) => a.meta.order - b.meta.order)
    })

    // Get Service by ID
    const getServiceById = (serviceId) => {
        return services.value.find(service => service.service_id == serviceId)
    }


    // Update Service
    const updateService = async (service, alert = true) => {
        // const response = await Ajax.post('admin_update_service', service)
        if (!service.category_id) {
            let uncategorised = categories.value.find(category => category.name == 'Uncategorised')
            if (uncategorised) {
                service.category_id = uncategorised.category_id
            } else {
                fetchCategories()
                console.log('uncategorised not found')
                return
            }
        }
        const response = service.service_id
            ? await model(service.service_id).update(service, service.service_id)
            : await model().create(service)

        // Log('Update Service', response)

        if (response.success) {
            // console.log('service updated', service)
            if (alert && service.status == 'archive') {
                Toast.success(`${String($settings.labels.service?.singular)} archived successfully`)
            } else if (alert && service.status == 'draft') {
                Toast.success(`${String($settings.labels.service?.singular)} draft saved successfully`)
            } else if (alert) {
                Toast.success(`${String($settings.labels.service?.singular)} ${service.service_id ? 'details updated' : 'added'} successfully`)
            }

            if (!service.service_id) {

                // Log('updated service', response.data)
                services.value.push({
                    ...response.data,
                    meta: {},
                    staffs: []
                })
            }
        } else {
            alert ? Toast.error(response.message || 'Something went wrong.') : ''
        }

        return response
    }


    // Delete service
    const deleteService = async (service_id) => {
        // const choice = await Prompt.fire({
        //     title: 'Are you sure?',
        //     message: 'You won\'t be able to revert this!',
        //     ok: 'Delete',
        //     cancel: 'Dismiss',
        // })

        // if (!choice.ok) return false

        // const response = await Ajax.post('admin_delete_service', { service_id })
        const response = await model(service_id).delete()

        if (response.success) {
            Toast.success(`${String($settings.labels.service?.singular)} deleted successfully`)
            services.value = services.value.filter(service => service.service_id !== service_id)
        } else {
            // Toast.error('Something went wrong.')
        }

        return response
    }

    /**
     * Models
     */
    const serviceModel = (service_id = null) => {
        return new Service({ service_id: service_id })
    }

    const categoryModel = (category_id = null) => {
        return new Category({ category_id: category_id })
    }


    // export
    return {
        state,
        fetchCategories,
        fetchServices,
        fetchData,

        isCategoryLoaded,
        isServiceLoaded,
        isLoaded,

        // categories,
        updateCategory,
        getCategories,
        getCategoryById,
        deleteCategory,
        // getOptionsCategories,

        updateService,
        getServices,
        getServiceById,
        deleteService,
        // filterServices,

        serviceModel,
        categoryModel
    }
})
